import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA
} from '@angular/material/dialog';

@Component({
  selector: 'sc-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.css']
})
export class MyDialogPopupComponent implements OnInit {
  public dataLangue = '';
  constructor(
    public dialogRef: MatDialogRef<MyDialogPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  public ngOnInit() {}

  public onClosedConfirm() {
    if (this.dataLangue) {
      this.dialogRef.close(this.dataLangue);
    } else {
      this.dialogRef.close('Confirm');
    }
  }

  public onClosedCancel() {
    this.dialogRef.close('Cancel');
  }
}
